// extracted by mini-css-extract-plugin
export default {"hsPageTitle":"PageTitle_hsPageTitle__MN9f6"};